import { isFuture } from 'date-fns';
// isInFuture(new Date('2099-12-17T14:30:00')) -> true
export const isInFuture = (value) => value === undefined ? false : isFuture(value);
